document.addEventListener("DOMContentLoaded", function () {

  const showPodListingSlider = document.querySelector(".showPodListingSlider");

  if (showPodListingSlider) {
    const showPodListingSliderGlide = document.querySelector(".showPodListingSlider__slider.glide");
    let totalSlides = 0;

    if (showPodListingSliderGlide) {

      const spGlide = new Glide(showPodListingSliderGlide, {
        type: 'slider',
        // autoplay: 5000,
        perView: 3.2,
        perTouch: 1,
        dragThreshold: false,
        // startAt: 0,
        // focusAt: 0,
        // keyboard: false,
        // hoverpause: true,
        // bound: true,
        gap: 38,
        breakpoints: {
          1900: {
            perView: 2.2
          },
          992: {
            perView: 2.2
          },
          768: {
            perView: 1.2,
            dragThreshold: 120,
          },
          480: {
            perView: 1
          }
        }
      });

      spGlide.mount();

    }

  }
});
